import { useSelector } from 'react-redux';

export const useBannerData = () => {
  const { introMessage, name, primaryColor, id } = useSelector(state => {
    if (state.demoData.newAirbo) {
      return {
        ...state.selectedCampaign,
        introMessage: state.selectedCampaign.welcomeMessage,
        primaryColor: state.selectedCampaign.color,
        id: state.demoData.id,
      };
    }
    return state.demoData;
  });

  return { introMessage, name, primaryColor, id };
};
